const getters = {
  master_settings: (state) => state.master_settings,
  masters: (state) => state.masters,
}

export default getters
